module.exports = __webpack_public_path__ + "static/media/fitmap.2bba6c69.svg";